import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import NewRoleForm from "./components/NewRoleForm";

const CreateRole = () => {
  return (
    <DashboardLayout title="Admin Management" back={false}>
      <Header title="Create Role" />
      <NewRoleForm />
    </DashboardLayout>
  );
};

export default CreateRole;
